import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import Demand from '../../types/models/Demand'
import dayjs from 'dayjs'
import DemandResponse from '../../types/response/DemandResponse'
import DemandState from '../../types/enums/DemandState'
import { changeEmptyStringsToNull, changeNullsToEmptyString } from '../../utils/falsyValuesConverter'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getDemands: builder.query<DemandResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'demand',
        params: props,
      }),
      transformResponse: (responseData: DemandResponse) => {
        return responseData
      },
      providesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),

    getDemandById: builder.query<Demand, string>({
      query: (demandId: string) => ({
        url: `demand/${demandId}`,
      }),
      transformResponse: (responseData: Demand) => {
        return changeNullsToEmptyString(responseData)
      },
      providesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),

    createDemand: builder.mutation({
      query: (demand: Partial<DemandModify>) => ({
        url: 'demand',
        method: 'POST',
        body: changeEmptyStringsToNull(demand),
      }),
      invalidatesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),

    editDemand: builder.mutation<Demand, EditArgs>({
      query: ({ id, demand }) => ({
        url: `demand/${id}`,
        method: 'PUT',
        body: changeEmptyStringsToNull(demand),
      }),
      invalidatesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),

    deleteDemand: builder.mutation<Demand, string>({
      query: (id: string) => ({
        url: `demand/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),

    changeDemandCompletion: builder.mutation<Demand, string>({
      query: (id: string) => ({
        url: `demand/change-completed/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: () => [{ type: 'Demand', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetDemandsQuery,
  useLazyGetDemandsQuery,
  useLazyGetDemandByIdQuery,
  useCreateDemandMutation,
  useEditDemandMutation,
  useDeleteDemandMutation,
  useChangeDemandCompletionMutation,
} = extendedApiSlice

export type DemandModify = {
  numberOfPeople: number
  technologies: TechState[]
  projectId: string
  startDate: dayjs.Dayjs | null
  submitterId: string
  state: DemandState
  completed: boolean
  description: string | null
  version: number
  vacancy: boolean
}

type EditArgs = {
  id: string
  demand: Partial<DemandModify>
}

type TechState = {
  technologyId: number
  level: number
}